export default __webpack_public_path__ + "static/media/tr-icon.ab906823.png";